<template>
  <section class="son-of-man-begins-speaking-in-house-churches-wrap" v-parallax>
    <v-page
      :background="[
        'images/Son-of-man-begins-speaking-in-house-churches/bg-0.jpg',
        'images/Son-of-man-begins-speaking-in-house-churches/bg-0-front.png',
      ]"
      :slide-up-in="true"
      v-slide-up-in
      v-parallax-background
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        :stageTitle="firstPageData.stage"
        v-slide-up-in-stage="1"
      />
      <v-btn class="down-arrow"><v-icon>expand_more</v-icon></v-btn>
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page1.data.content" />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :title="pageDataItem.page2.data.title"
        :html="pageDataItem.page2.data.content"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page3ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page3.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page4ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page4.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page5.data.content"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page7ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page6.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page8ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page7.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page10ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page8.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page9.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/Son-of-man-begins-speaking-in-house-churches/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page10.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page11.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-full-screen-songs-player
        :data="pageDataItem.page12.data"
        bg="images/common/hymnsPosters/Son-of-man-begins-speaking-in-house-churches.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-picture-wall :data="pageDataItem.page13.data" />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-chatper-entry bg-color="earth" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  components: {},
  data() {
    return {
      chapterTitle: "",
      pageDataItem: {},
      firstPageData: {},
    };
  },
  created() {
    this.pageDataItem = this.schema[
      "Son-of-man-begins-speaking-in-house-churches"
    ].item;
    this.chapterTitle = this.pageDataItem.page1.data.chapterTitle;
    this.firstPageData = this.schema.global.item.aside.data[3];
  },
};
</script>
<style lang="scss">
.son-of-man-begins-speaking-in-house-churches-wrap {
  .v-page {
    .v-picture-wall {
      padding-top: 80px;
    }
  }
}
</style>
